var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9021 29.0364V41.9415H34.6758L41.1283 49.2007L47.5809 41.9415H44.3546V29.0364H37.9021Z",
    fill: "#373163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9965 0C19.9003 0.00144031 14.9258 1.55987 10.7409 4.46712C6.555 7.37401 3.35747 11.4908 1.57655 16.2652C-0.20436 21.0402 -0.483849 26.2455 0.775741 31.1836C2.03529 36.1217 4.7733 40.5574 8.62402 43.8952C12.4744 47.2339 17.2529 49.3158 22.3192 49.8631C27.3858 50.4101 32.4986 49.3957 36.973 46.9562L33.4691 43.0137C33.1922 42.7022 33.0463 42.2953 33.0625 41.8788C33.0791 41.4622 33.2559 41.0679 33.5565 40.7787C33.8572 40.4899 34.258 40.3286 34.675 40.3286H36.2881V29.0366C36.2881 28.6088 36.4581 28.1983 36.7605 27.8958C37.063 27.5934 37.4735 27.4234 37.9013 27.4234H44.3538C44.7816 27.4234 45.1921 27.5934 45.4946 27.8958C45.797 28.1983 45.967 28.6088 45.967 29.0366V38.6131C49.2498 33.5576 50.5958 27.4861 49.7564 21.5175C48.9171 15.5484 45.9489 10.0835 41.399 6.12988C36.8491 2.17583 31.0242 -0.00081116 24.9956 0.000663717L24.9965 0ZM13 21.5175L22.7485 25.1884L40 12.5L23.2208 29.0366L13 21.5175Z",
    fill: "#373163"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/ST.75c7065215492eb5024acff6e8fdbb7c.svg";
export { ForwardRef as ReactComponent };